// extracted by mini-css-extract-plugin
module.exports = {"mainBox":"page_mainBox__nR1nN","insideBox":"page_insideBox__pRE3i","description":"page_description__l2EYT"};